import { useCountriesStore } from "@multicines/stores";
import { useMoviesStore } from "@multicines/stores";
import { Movie } from "@multicines/types";
import { titleCase } from "@multicines/utils";
import dayjs from "dayjs";
import React from "react";
import "dayjs/locale/es";

import Styles from "./PreviewFilter.styles";
import { PreviewFilterProps as Props } from "./PreviewFilter.types";
import MovieCard from "components/global/MovieCard/MovieCard";

const PreviewFilter: React.FC<Props> = props => {
  const { movie } = props;
  const selectedCountry = useCountriesStore(state => state.selectedCountry);
  const setSelectedMovie = useMoviesStore(store => store.setSelectedMovie);
  const { locale } = selectedCountry;

  const renderItem = (movies: Movie[]) => {
    if (!movies) return null;

    return movies.map(movie => {
      const pressHandler = () => setSelectedMovie(movie);
      const { id } = movie;

      return <MovieCard key={id} movie={movie} onClick={pressHandler} />;
    });
  };

  const renderSectionHeader = (openingDate: string) => {
    const month = dayjs(openingDate).locale(locale).format("MMMM YYYY");

    return <p className="PreviewFilter__month">{titleCase(month)}</p>;
  };

  return (
    <Styles className="PreviewFilter">
      {movie.map((item, index) => {
        return (
          <>
            {renderSectionHeader(item[0]?.openingDate)}
            <div className="PreviewFilter__content" key={index}>
              {renderItem(item)}
            </div>
          </>
        );
      })}
    </Styles>
  );
};
PreviewFilter.defaultProps = {};

export default PreviewFilter;
